import React, { useEffect, useState } from 'react'
import { Translate } from '../../../../language'
import InputTextArea from '../../../../utils/components/InputTextArea/InputTextArea'
import useModal from '../../../../utils/hooks/useModal'
import CardProductOutput from './Cards/CardProductOutput'
import { useDispatch, useSelector } from 'react-redux';
import { clearBatchesByProduct, getBatchesByProduct } from '../../../actions/wineryBatchesActions'
import { addSpecification, clearSpecification, mmanageOrder } from '../../../actions/transferActions'
import style from './Order.module.css'
import { Table } from '../../../components/Table/Table'
import Button from '../../../../utils/components/Button/Button'
import { TransferIcon } from '../../../../assets/icons'
import TitleSVG from '../../../../utils/components/TitleSVG/TitleSVG'
const OrderDetailView = ({ subOrders, mmanageOrder, order, reject }) => {
    const dispatch = useDispatch()
    const [ref, isShowBatches, setIsShowBatches] = useModal(false)
    const [refRechazo, isShowRechazo, setIsShowRechazo] = useModal(false)
    const { specifications } = useSelector(state => state.tranfers)
    const [subOrderState, setSubOrder] = useState(null)
    const [batchesList, setBatchesList] = useState(new Map())
    useEffect(() => {


        return () => {
            if (!isShowBatches) {
                dispatch(clearBatchesByProduct())
            }
        }
    }, [isShowBatches])


    if (!order) {
        return (
            <div>
                cargando
            </div>
        )
    }
    return (
        <div>

            <TitleSVG Icon={TransferIcon}
                titleHighlight={'Detalle'}
                title={' de la orden'} />

            <h3 className={`admin-subtitle`}>Información del comprador</h3>
            <div>
                {
                    (order.deliveryAddress  ) && (
                    <>    
                        <Table>
                            <thead>
                                <tr>
                                    <th>Cedula</th>
                                    <th>Correo electronico</th>
                                    <th>Telefono</th>
                                    <th>Nombre</th>
                                    <th>Apellido</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{typeof order.deliveryAddress.currentNationalId == "string" ? order.deliveryAddress.currentNationalId : ""}</td>
                                    <td>{typeof order.deliveryAddress.currentEmail == "string" ? order.deliveryAddress.currentEmail : ""}</td>
                                    <td>{typeof order.deliveryAddress.currentPhone == "string" ? order.deliveryAddress.currentPhone : ""}</td>
                                    <td>{typeof order.deliveryAddress.currentName == "string" ? order.deliveryAddress.currentName : ""}</td>
                                    <td>{typeof order.deliveryAddress.currentLastName == "string" ? order.deliveryAddress.currentLastName : ""}</td>
                                </tr>
                            </tbody>
                        </Table>
                        
                        <Table>
                            <thead>
                                <tr>
                                    <th>País</th>
                                    <th>Departamento</th>
                                    <th>Ciudad</th>
                                    <th>Barrio</th>
                                    <th>Dirección</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{typeof order.deliveryAddress.currentCountry == "string" ? order.deliveryAddress.currentCountry : ""}</td>
                                    <td>{typeof order.deliveryAddress.currentDepartment == "string" ? order.deliveryAddress.currentDepartment : ""}</td>
                                    <td>{typeof order.deliveryAddress.currentCity == "string" ? order.deliveryAddress.currentCity : ""}</td>
                                    <td>{typeof order.deliveryAddress.currentLocation == "string" ? order.deliveryAddress.currentLocation : ""}</td>
                                    <td>{typeof order.deliveryAddress.currentAddress == "string" ? order.deliveryAddress.currentAddress : ""}</td>
                                </tr>
                            </tbody>
                        </Table>
                        </>
                        
                    )
                }
            </div>
            <h3 className={`admin-subtitle`}>Información de la compra</h3>
            <div className={`${style.table_container} margin-top-20`}>
                <Table>
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Precio</th>
                            <th>Nombre</th>
                            <th>Cantidad</th>
                            {
                                order.status === 2 && <th>Gestionar</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            subOrders.map(subOrder => (
                                <tr key={subOrder.productId._id}>
                                    <td>{subOrder.productId.code}</td>
                                    <td>{subOrder.productId.price}</td>
                                    <td>{subOrder.productId.name}</td>
                                    <td>{subOrder.orderedQuantity}</td>
                                    {
                                        order.status === 2 && (
                                            <td>
                                                <div
                                                    className={`cursor-pointer secondary-color animate__animated animate__fadeIn`}
                                                    onClick={() => {
                                                        dispatch(getBatchesByProduct(subOrder.productId._id))
                                                        setSubOrder(subOrder)
                                                        if (specifications.find(specification => specification.subOrderId === subOrder._id) === undefined) {
                                                            setBatchesList(new Map())
                                                        } else {
                                                            const batches = specifications.find(specification => specification.subOrderId === subOrder._id).batches
                                                            console.log();
                                                            setBatchesList(new Map(batches.map(batch => [batch._id, batch])))
                                                        }

                                                        setIsShowBatches(true)

                                                        //setBatchesList(new Map())
                                                    }}>Gestionar</div>

                                            </td>
                                        )
                                    }

                                </tr>
                            ))
                        }
                    </tbody>
                </Table>



                <ModalBatches
                    batchesList={batchesList}
                    setBatchesList={setBatchesList}
                    item={subOrderState} isShowModal={isShowBatches} close={() => {

                        setBatchesList(new Map());
                        setIsShowBatches(false)
                    }} />
                <ModalRechazo isShowModal={isShowRechazo} close={() => { setIsShowRechazo(false) }} reject={reject} />


                <div className='center-70 flex-row-center margin-top-20 animate__animated animate__bounceIn'>

                    {
                        order.status === 2 && (
                            <Button onClick={() => { setIsShowRechazo(true) }} text="Rechazar" />
                        )
                    }
                    {
                        order.status === 0 && (
                            <Button onClick={() => {
                                mmanageOrder(2)

                            }} text="Aprobar" />
                        )
                    }
                                        {
                        order.status === 0 && (
                            <Button onClick={() => {
                                mmanageOrder(2)

                            }} text="Generar factura electronica" />
                        )
                    }


                    {
                        order.status === 2 && (
                            <Button
                                disabled={specifications.length < subOrders.length}
                                onClick={() => {
                                    mmanageOrder(3)

                                }} text="Transferir" />
                        )
                    }


                    {
                        order.status === 3 && (
                            <Button onClick={() => {
                                mmanageOrder(4)

                            }} text="Entregar" />
                        )
                    }
                </div>

            </div>
        </div>
    )
}
const ModalBatches = ({ batchesList, setBatchesList, item, isShowModal, close }) => {
    const divStyle = {
        display: isShowModal ? 'block' : 'none'
    };
    const dispatch = useDispatch()
    const { wineryBatchesList } = useSelector(state => state.wineryBatchesAdmin)

    if (!item) {
        return <></>
    }
    const totalStockBatches = Array.from(batchesList.values()).reduce((n, { quantityStock }) => n + quantityStock, 0);

    const amountRemaining = (item.orderedQuantity - totalStockBatches > 0) ? item.orderedQuantity - totalStockBatches : 0
    return (
        <>{item &&
            <div style={divStyle}
                onClick={close}
                className="modal">
                <div
                    onClick={e => e.stopPropagation()}
                    className="modal-content modal-report-post"
                >
                    <div>
                        <div>

                            <div className={`admin-subtitle flex-row-center`}>
                                {item.orderedQuantity === 1 ? <span> Seleccione de donde saldrá {item.orderedQuantity} unidad del producto: {item.productId.name}</span> :
                                    <span> Seleccione de donde saldrán {item.orderedQuantity} unidades del producto: {item.productId.name}</span>}
                            </div>

                        </div >
                        <div className={`margin-top-30`}>
                            <div className={style.batch_list_orders}>
                                {
                                    wineryBatchesList.map(batch => (
                                        <CardProductOutput
                                            checked={batchesList.has(batch._id)}
                                            index={Array.from(batchesList).findIndex(([key]) => key === batch._id)}
                                            expeditionDate={batch.expeditionDate}
                                            expirationDate={batch.expirationDate}
                                            name={batch.wineryId.name}
                                            code={batch.code}
                                            stock={batch.quantityStock}
                                            id={batch._id}
                                            handleOnChange={() => {

                                                setBatchesList(oldList => {


                                                    const unsortedArray = [...oldList]

                                                    /*  
                                                         // no ordenar de momento
                                                         const sortedArray = unsortedArray.sort(([key1, batch1], [key2, batch2]) => {
                                                         return new Date(batch1.expirationDate) - new Date(batch2.expirationDate)
                                                     }) */
                                                    const newList = new Map(unsortedArray)
                                                    if (newList.has(batch._id)) {
                                                        newList.delete(batch._id)
                                                    } else {
                                                        //     const newTotal = [...Array.from(newList.values()),batch].reduce((n, { quantityStock }) => n + quantityStock, 0);

                                                        if (item.orderedQuantity - amountRemaining < item.orderedQuantity) {



                                                            newList.set(batch._id, batch)
                                                        }


                                                    }
                                                    return newList;

                                                })
                                            }}

                                        />
                                    ))
                                }
                            </div>

                        </div>

                        <div className={`margin-top-20 flex-row-center admin-subtitle admin-highlight-text`}>
                            {item.orderedQuantity - amountRemaining} de {item.orderedQuantity}
                        </div>

                        <div className='flex-row-center column mt-5'>
                            <Button onClick={() => {
                                close()
                            }} text="Cancelar" />
                            <Button
                                classNameContent={`margin-right-10`}
                                disabled={amountRemaining > 0}
                                onClick={() => {

                                    dispatch(addSpecification({
                                        subOrderId: item._id,
                                        batches: Array.from(batchesList.values())
                                    }))

                                    close()
                                }} text="Guardar" />

                        </div>
                    </div>
                </div >
            </div >
        }
        </>
    )
}
const ModalRechazo = ({ isShowModal, close, reject }) => {
    const divStyle = {
        display: isShowModal ? 'block' : 'none'
    };
    const [motive, setMotive] = useState("")


    return <div className="modal"
        onClick={close}
        style={divStyle}>
        <div
            onClick={e => e.stopPropagation()}
            className="modal-content modal-report-post">
            <div>
                <div className={`admin-subtitle flex-row-center`}>Motivo del rechazo</div>
                <InputTextArea
                    setValue={setMotive}
                    name='comment'
                    value={motive}
                    type='primary border margin-top-10'
                />

                <div className={`margin-top-20`}>
                    <button className={`button-style white`} onClick={() => reject(motive)}>Guardar</button>
                </div>


            </div>

        </div>
    </div>
}
export default OrderDetailView
